/* TDR Form Modal — open/close + focus trap + ESC + body scroll lock.
   Portals the modal element to body on open so the focus-trap inert sweep
   on siblings doesn't accidentally catch the modal (when its origin is
   nested deep in the DOM). */
(function () {
  'use strict';
  var openModalEl = null;
  var lastFocus = null;

  function portalToBody(el) {
    if (el.parentNode === document.body) return;
    el._tdrOrigParent = el.parentNode;
    el._tdrOrigNext = el.nextSibling;
    document.body.appendChild(el);
  }

  function returnFromPortal(el) {
    if (!el._tdrOrigParent) return;
    if (el._tdrOrigNext && el._tdrOrigNext.parentNode === el._tdrOrigParent) {
      el._tdrOrigParent.insertBefore(el, el._tdrOrigNext);
    } else {
      el._tdrOrigParent.appendChild(el);
    }
    el._tdrOrigParent = null;
    el._tdrOrigNext = null;
  }

  function openModal(id) {
    var el = document.querySelector('[data-tdr-form-modal="' + id + '"]');
    if (!el) return;
    closeModal();
    lastFocus = document.activeElement;
    portalToBody(el);
    el.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    openModalEl = el;
    Array.prototype.forEach.call(document.body.children, function (c) {
      if (c !== el && c.tagName !== 'SCRIPT') {
        c.setAttribute('inert', '');
        c.setAttribute('aria-hidden', 'true');
      }
    });
    var panel = el.querySelector('.tdr-fm__panel');
    if (panel) panel.focus({ preventScroll: true });
    if (window.matchMedia('(min-width: 720px)').matches) {
      var firstInput = el.querySelector('input:not([type="hidden"]), textarea, button:not([data-tdr-form-close])');
      if (firstInput) setTimeout(function () { firstInput.focus({ preventScroll: true }); }, 280);
    }
  }

  function closeModal() {
    if (!openModalEl) return;
    openModalEl.setAttribute('hidden', '');
    Array.prototype.forEach.call(document.body.children, function (c) {
      if (c.tagName !== 'SCRIPT') {
        c.removeAttribute('inert');
        c.removeAttribute('aria-hidden');
      }
    });
    returnFromPortal(openModalEl);
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    openModalEl = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-tdr-form-open]');
    if (trigger) {
      e.preventDefault();
      openModal(trigger.getAttribute('data-tdr-form-open'));
      return;
    }
    var closer = e.target.closest('[data-tdr-form-close]');
    if (closer && openModalEl && openModalEl.contains(closer)) {
      e.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openModalEl) closeModal();
  });

  // Auto-open if URL has ?form=<id>
  document.addEventListener('DOMContentLoaded', function () {
    var url = new URL(window.location.href);
    var id = url.searchParams.get('form');
    if (id) openModal(id);
  });
})();
